import * as React from 'react';

// style helpers
import { StyleSheet, color, css, font, spacing, zIndex } from '@coursera/coursera-ui';

// components
import Button from 'bundles/coursera-ui/components/basic/Button';
import ActionCheckCircle from 'bundles/coursera-ui/components/svg/coursera/common/ActionCheckCircle';
// svg icons
import ActionInfo from 'bundles/coursera-ui/components/svg/coursera/common/ActionInfo';
import AlertError from 'bundles/coursera-ui/components/svg/coursera/common/AlertError';
import AlertWarning from 'bundles/coursera-ui/components/svg/coursera/common/AlertWarning';
import NavClose from 'bundles/coursera-ui/components/svg/coursera/common/NavigationClose';
import { lighten } from 'bundles/coursera-ui/utils/colorUtils';

// common styles based on type
function getTypeStyles(type: $TSFixMe) {
  return {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    backgroundColor: lighten(color[type], 0.85),
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    border: `1px solid ${color[type]}`,
  };
}

const styles = StyleSheet.create({
  Notification: {
    width: '100%',
    padding: spacing.sm,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: zIndex.md,
    fontSize: font.xs,
  },
  icon: {
    padding: spacing.sm,
  },
  message: {
    paddingLeft: spacing.sm,
  },
  messageNoIcon: {
    paddingLeft: 0,
  },
  action: {
    padding: spacing.sm,
  },
  dismiss: {
    marginLeft: 'auto',
  },
  info: getTypeStyles('info'),
  warning: getTypeStyles('warning'),
  success: getTypeStyles('success'),
  danger: getTypeStyles('danger'),
});

// map icon type to component
const ICON_MAP = {
  info: ActionInfo,
  warning: AlertWarning,
  danger: AlertError,
  success: ActionCheckCircle,
};

/**
 * A customizable Notification component to show a message with an optional
 * call-to-action and an optional dismiss.
 */
type Props = {
  // used to infer colors and icon
  type?: 'info' | 'success' | 'warning' | 'danger';
  // customized icon,
  icon?: React.ReactNode;
  // size of icon in px
  iconSize?: number;
  hideIcon?: boolean;
  // we may need to display a title or some timestamps on top
  header?: React.ReactNode;
  // body of notification (we can use Expandable/TextTruncate)
  content?: React.ReactNode;
  // notification message
  message?: string | React.ReactNode;
  // whether to allow dismissing the notification
  isDismissible?: boolean;
  // callback when notification is dismissed
  // Original propType: func
  onDismiss?: (...args: $TSFixMe[]) => $TSFixMe;
  // time in milliseconds to wait before dismissing notification
  dismissAfter?: number;
  // CTA node for the notification
  action?: React.ReactNode;
  // callback for CTA node
  // Original propType: func
  onAction?: (...args: $TSFixMe[]) => $TSFixMe;

  // Original propType: object
  htmlAttributes?: $TSFixMe;
  // Override the inline-styles of the root element
  style?: React.CSSProperties;
  /* // eslint-enable react/forbid-prop-types */

  isThemeDark?: boolean;
  // lite version of notification, with minimum styling
  isLite?: boolean;
};

class Notification extends React.Component<Props> {
  static defaultProps = {
    type: 'info',
    htmlAttributes: {},
    style: {},
    hideIcon: false,
    iconSize: 21,
    message: '',
    isDismissible: false,
    action: null,
    isThemeDark: false,
    isLite: false,
  };

  renderIcon = () => {
    const { type, iconSize } = this.props;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const Icon = ICON_MAP[type];

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return <Icon size={iconSize} color={color[type]} />;
  };

  renderMessage = () => {
    const { message, hideIcon } = this.props;

    return <span {...css(hideIcon ? styles.messageNoIcon : styles.message)}>{message}</span>;
  };

  renderAction() {
    // @ts-expect-error TS2322 Button's `label` prop is typed `string`, but `action` is `React.ReactNode` here; pre-existing mismatch, not introduced by this typing pass.
    return <Button type="link" size="sm" label={this.props.action} onClick={this.props.onAction} />;
  }

  renderDismiss() {
    return (
      // @ts-expect-error FIXME result of fixing typing on coursera-ui aphrodite exports in PR#45351
      <div className="notification-dismiss" {...css(styles.dismiss)}>
        <Button size="sm" type="link" onClick={this.props.onDismiss}>
          <NavClose size={this.props.iconSize} />
        </Button>
      </div>
    );
  }

  render() {
    const { htmlAttributes, style, type, isLite } = this.props;

    return (
      // @ts-expect-error FIXME result of fixing typing on coursera-ui aphrodite exports in PR#45351
      <div {...htmlAttributes} {...css(styles.Notification, !isLite && styles[type])} style={style}>
        {!this.props.hideIcon && this.renderIcon()}
        {this.renderMessage()}
        {this.props.action && this.renderAction()}
        {this.props.isDismissible && this.renderDismiss()}
      </div>
    );
  }
}

export default Notification;
